import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function addTopicToClauses(requestor) {
  return createReduxPromiseAction(
    ActionTypes.CLAUSES_TOPIC_ADD,
    (organisationId, topicId, data) =>
      requestor
        .post(
          `${basePath}/organisation/${organisationId}/topic/${topicId}/add-clauses`,
          data,
          {withCredentials: true},
        )
        .then(response => response.data),
  );
}
